export const TRADE_IN_STATUS = Object.freeze({
  QUOTE: 1, // đã báo giá
  COLLECTED: 2, // đã thu cũ
})

export const TRADE_IN_TYPE = Object.freeze({
  TRADE_IN: 1, // Khách thu cũ đổi mới
  BUYING_OLD_ITEMS: 2, // Khách thu cũ không đổi mới
  EXCHANGE_WARRANTY: 3, // Khách đổi bảo hành
  TEST_IMEI: 4, // Kiểm tra IMEI
})

export const CUSTOMER_TYPE = Object.freeze({
  RETAIL_CUSTOMER: 1,       // khách lẻ
  WHOLESALE_CUSTOMER: 2,    // khách buôn
  AGENCY: 3,                // đại lý
  VIP: 4,                   // vip
  KOL: 5,                   // kol
  INSTALLMENT: 6,           // trả góp
  CREDIT: 7,                // tín dụng
  PERSONAL: 8,              // cá nhân
  BUSINESS_HOUSEHOLD: 9,    // hộ kinh doanh
  COMPANY: 10,              // công ty
})

export const GENDER = Object.freeze({
  FEMALE: 0,
  MALE: 1,
})

/**
 * Tương ứng với STATUS_COMMON ở backend
 * ACTIVE = 1, DEACTIVE = 0
 */
export const CUSTOMER_STATUS = Object.freeze({
  ACTIVE: 1,   // Hoạt động / Đang giao dịch
  DEACTIVE: 0, // Ngưng giao dịch
})

export const TYPE_ORDER = Object.freeze({
  SHOP: 1, // Mua tại quầy
  PREORDER: 2, // Đặt trước
  SHIPPING: 3, // Chuyển hàng
  EX_SHIPPING: 4, // Hãng vận chuyển
  WEBSITE: 5, // Website
  WHOLESALE: 6, // Bán buôn
})

export const PARTNER_PAYMENT = Object.freeze({
  SUCCESS: 1, // Thành công
  FAILED: 2, // Thất bại
  AGREE_DEPOSIT: 3, // Đồng ý cọc
  DEPOSIT: 4, // Đã đặt cọc
})

export const PAYMENT_STATUS = Object.freeze({
  SUCCESS: 1,
  FAILED: 2,
})

export const LOAN_APPLICATION_STATUS = Object.freeze({
  INIT: 1,
  SUBMITED: 2,
  APPROVED: 3,
  REJECTED: 4,
  DISBURSED: 5,
  OP_PROCESSING: 6,
})

export const CRITERIA_FILTER_BILL = Object.freeze({
  HAVE_DISCOUNT: 1, // Có tiền chiết khấu
  NO_DISCOUNT: 2, //Không có tiền chiết khấu
  HAVE_TRANSFER: 3, // Có tiền chuyển khoản
  HAVE_CREDIT: 4, // Có thanh toán quẹt thẻ
  HAVE_INSTALLMENT: 5, // Có thanh toán trả góp
  USE_POINT: 6, // Có dùng tiền tích điểm
  HAVE_DEBT: 7, // Có công nợ
  STILL_OWE: 8, // Còn công nợ
  OUT_OF_DEBT: 9, // Hết công nợ
  HAVE_CASH: 10, // Có tiền mặt
  FROM_ORDER: 11, // Hóa đơn từ đơn hàng
  HAVE_GIFT: 12, //Có quà tặng
  HAVE_DEPOSIT: 13, // có cọc từ đơn hàng
  UNDERPAYMENT: 14, // còn thiếu tiền
  UNPAID: 15, // chưa thanh toán
  NO_CODESHIP: 16, // chưa gắn code ship
  USE_COUPON: 17,
  OVERPAYMENT: 18, // thanh toán dư
  /** Đơn có orderId khớp PlatformOrders + MarketplaceConnections.platform = shopee */
  ORDER_FROM_SHOPEE: 20,
  /** Đơn có orderId nhưng không phải đơn Shopee theo định nghĩa trên */
  ORDER_FROM_APP: 21,
})

export const APPROVAL_TYPE_ENUM = Object.freeze({
  OVER_PAYMENT: 1, // thanh toán dư
  BUY_OLD: 2, // thu cũ
  REFUND: 3, // trả hàng
  TRADE_IN: 4, // thu cũ đổi mới
  VAT: 5, // xuất hóa đơn VAT
  DEPOSIT: 6, // hoàn cọc
})

export const APPROVAL_PAYMENT_TYPE = Object.freeze({
  CASH: 1,
  TRANSFER: 2,
})

export const APPROVAL_ENTITY_TYPE = Object.freeze({
  BILL: 1, // hóa đơn bán hàng
  ORDER: 2, // đơn hàng
  STOCK_SLIP: 3, // phiếu thu cũ
})

export const REFERENCE_TYPE = Object.freeze({
  BILL: 1,
  ORDER: 2,
})

export const MODAL_TYPE_UPSERT_ORDER = Object.freeze({
  GIFT: 'gift',
  ATTACH: 'attach',
  PRODUCT_IMEI: 'note',
  CHANGE_GIFT: 'change-gift',
  CHANGE_MAIN: 'change-main',
})

export const ERROR_CODE = Object.freeze({
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  ERROR_INTERNAL: 500,
  ERROR_VERSION: 900,
})

export const PRODUCT_TYPE = Object.freeze({
  PRODUCT: 1, // sản phẩm
  PRODUCT_IMEI: 2, // sản phẩm IMEI
  PRODUCT_COMBO: 3, // sản phẩm combo
  PRODUCT_SERVICE: 4, // sản phẩm dịch vụ
  PRODUCT_COMPONENT: 7, // sản phẩm linh kiện
})

export const BILL_MODE = Object.freeze({
  APP: 1, // kênh App
  SHOPEE: 2, // kênh Shopee
  EXCHANGE: 3, // hóa đơn xuất đổi
})

export const EXCHANGE_REASON = Object.freeze({
  WRONG_PRODUCT_CODE: 1, // xuất sai mã sản phẩm
  WRONG_IMEI: 2, // xuất sai mã IMEI
  CUSTOMER_EXCHANGE: 3, // khách đổi máy
})

export const PRODUCT_STATUS = Object.freeze({
  NEW: 1, // mới
  SELLING: 2, // đang bán
  STOP_SELLING: 3, // ngừng bán
  OUT_OF_STOCK: 4, // hết hàng
})

export const VAT_AMOUNT = Object.freeze({
  PERCENT_0: 0,
  PERCENT_5: 5,
  PERCENT_8: 8,
  PERCENT_10: 10,
  PERCENT_KCT: -1,
})

export const COUPON_SCOPE_CHANNEL = Object.freeze({
  BOTH: 1,
  OFFLINE: 2,
  ONLINE: 3,
})

export const DISCOUNT_AMOUNT_TYPE = Object.freeze({
  MONEY: 1,
  PERCENT: 2,
})

export const DISCOUNT_TYPE = Object.freeze({
  Money: '1',
  Percentage: '2',
})

export const AMOUNT_TYPE = Object.freeze({
  MONEY: 1,
  PERCENT: 2,
})

export const HISTORY_ACTION_TYPE = Object.freeze({
  UPDATE: 1, // cập nhật
  DELETE: 2, // xóa
  CREATE: 3, // tạo mới
  UPDATE_NOTE: 4, // cập nhật ghi chú
  UPDATE_STATUS: 5, // cập nhật trạng thái
  CHANGE_STORE: 6, // chuyển CH bảo hành
  CONFIRM_CHANGE_STORE: 7, // Xác nhận nhận má
})

export const ACTION_TYPE = Object.freeze({
  CREATE: 1,
  UPDATE: 2,
})

export const PAYMENT_TYPE = Object.freeze({
  CASH: 1,
  TRANSFER: 2,
  CREDIT: 3,
  INSTALLMENT: 4,
  CREDIT_FEE: 5,
  REFUND: 6,
  INSTALLMENT_FEE: 7,
  DEPOSIT: 8,
})

export const ACCOUNTANT_TYPE = Object.freeze({
  CASH: 1,     // tài khoản tiền mặt
  BANK: 2,     // tài khoản ngân hàng (chuyển khoản)
  CREDIT: 3,   // tài khoản quẹt thẻ
  INSTALLMENT: 4, // tài khoản trả góp
})

export const ITEM_TYPE = Object.freeze({
  MAIN: 1,
  GIFT: 2,
  ATTACH: 3,
})

export const STOCK_SLIP_TYPE = Object.freeze({
  IMPORT_PROVIDER: 1,
  EXPORT_PROVIDER: 2,
  TRANSFER: 3,
  REQUEST_TRANSFER: 5,
  EXPORT_STOCK_TO_SALE: 6, // xuat kho ban le
  EXPORT_STOCK_TO_SALE_WHOLSE: 7, // xuat kho ban buon
  IMPORT_STOCK_FROM_BILL: 8, // nhap kho tu phieu tra hang
  IMPORT_STOCK_FROM_ORDER: 9, // nhap kho tu don chuyen hoan
  EXPORT_TO_SHIPPING: 10, // xuat kho giao hang
  IMPORT_FROM_TRADE_IN: 11, // nhap kho thu cũ
  IMPORT_WARRANTY: 15, // nhập kho bảo hành
  EXPORT_WARRANTY: 16, // xuất kho bảo hành
  IMPORT_HOLDING: 17, // nhập giữ hàng
  EXPORT_HOLDING: 18,
  TRANSFER_WARRANTY_STOCK: 19, // chuyen kho bao hanh
  REQUIRE_EXPORT_WARRANTY_STOCK: 20, // yeu cau xuat chuyen kho bao hanh
  REQUIRE_IMPORT_WARRANTY_STOCK: 21, // yeu cau nhap chuyen kho bao hanh
  IMPORT_STOCK_FROM_WARRANTY_BILL: 22,
  IMPORT_WARRANTY_FROM_BILL: 23,
  EXPORT_WARRANTY_FROM_BILL: 24, // xuất kho bảo hành từ hóa đơn bảo hành
  EXPORT_STOCK_BY_WARRANTY_BILL: 25, // xuất kho bởi trả khác mã từ hóa đơn bảo hành
  EXPORT_WARRANTY_TO_PROVIDER: 26, // xuất kho bảo hành trả nhà cung cấp
  UPDATE_EXPORT_WARRANTY_TO_PROVIDER: 27, // cập nhật phiếu xuất kho bảo hành trả ncc
  DELETE_EXPORT_WARRANTY_TO_PROVIDER: 28, // xóa phiếu xuất kho bảo hành trả ncc
  CREATE_WARRANTY_COMPLETION_SLIP: 29, // tạo phiếu hoàn tất bảo hành
  DELETE_WARRANTY_COMPLETION_SLIP: 30, // xoá phiếu hoàn tất bảo hành
  IMPORT_STOCK_BY_WARRANTY_COMPLETION: 31, // nhập kho bởi phiếu hoàn tất bảo hành
  EXPORT_STOCK_BY_WARRANTY_COMPLETION: 32, // xuất kho bởi phiếu hoàn tất bảo hành
  EXPORT_WARRANTY_STOCK_BY_DELETE_WARRANTY_BILL: 33, // xuất kho bảo hành bởi bởi xoá hoá đơn bảo hành
  IMPORT_STOCK_BY_DELETE_WARRANTY_BILL: 34, // nhập kho bởi bởi xoá hoá đơn bảo hành
  IMPORT_STOCK_BY_DELETE_STORE_WARRANTY_BILL: 35, // nhập kho bởi bởi xoá hoá đơn bảo hành (lỗi cửa hàng)
  EXPORT_STOCK_BY_CREATE_STORE_WARRANTY_BILL: 36, // xuất kho bởi tạo hoá đơn bảo hành (lỗi cửa hàng)
  EXPORT_STOCK_BY_INVENTORY_CHECK: 37, // xuất kho từ phiếu kiểm kê sản phẩm
  IMPORT_STOCK_BY_INVENTORY_CHECK: 38, // nhập kho từ phiếu kiểm kê sản phẩm
  EXPORT_LENDING: 39, // xuất kho cho mượn máy
  IMPORT_STOCK_LENDING: 40, // nhập kho cho mượn máy
  IMPORT_WARRANTY_FROM_PROVIDER: 41, // nhập kho bảo hành nhà cung cấp (tồn thực tế)
  IMPORT_FROM_CHANGE_PRODUCT: 42, // nhập kho từ phiếu chuyển mã sản phẩm IMEI
  EXPORT_FROM_CHANGE_PRODUCT: 43, // xuất kho từ phiếu chuyển mã sản phẩm IMEI
  IMPORT_FROM_CHANGE_IMEI: 44, // nhập kho từ phiếu đổi IMEI
  EXPORT_FROM_CHANGE_IMEI: 45, // xuất kho từ phiếu đổi IMEI
  IMPORT_WARRANTY_OUTSOURCE: 55, // Nhập kho từ outsource
  IMPORT_HKD: 1001, // Nhập kho HKD
  EXPORT_HKD: 1002, // Xuất kho HKD
})

export const STOCK_SLIP_STATUS = Object.freeze({
  NEW: 1, // mới
  APPROVED: 2, // đã duyệt
  CONFIRMED: 3, // đã xác nhận
  CANCELD: 4,
})

export const CONTACT_TYPE = Object.freeze({
  Customer: '1',
  Provider: '2',
  Installment: '3',
  Employee: '4',
  Credit: '5',
  ShiftWork: '6',
  Ecommerce: '21',
  Other: '20',
  ShipFee: '22',
})

export const TRANSACTION_TYPE = Object.freeze({
  CashIn: '1', // Phiếu thu
  CashOut: '2', // Phiếu chi
  BankIn: '3', // Báo có (nộp tiền)
  BankOut: '4', // Báo nợ (Rút tiền)
  StockImport: '8', // Phiếu nhập
  GoodsIssue: '9', // Phiếu xuất hàng
  Sale: '6', // Phiếu bán hàng
  MerchandiseReturn: '5', // Phiếu bán hàng
})

export const FILE_UPLOAD_STATUS = Object.freeze({
  NEW: 1, // Mới
  EXIST: 2, // Tồn tại
})

export const FILE_UPLOAD_MODE = Object.freeze({
  INITIAL: 0, // Mới
  SAVING: 1, // Tồn tại
  SUCCESS: 2, // Tồn tại
  FAILED: 3, // Tồn tại
})

export const APPROVAL_STEP_STATUS = Object.freeze({
  NEW: 1,
  APPROVED: 2,
  CANCELED: 3,
  PAID: 4,
  PAY_FAILED: 5,
  COMPLETED: 6,
  ON_APPROVE: 7,
  CHECKED: 8,
  TRANSFER_ORDER_INITIALTED: 9, //Wait for transfer information from bank
})

export const OPERATOR_TYPE = Object.freeze({
  NONE: 1, // không xác định (--)
  LT: 2, // nhỏ hơn (<)
  GT: 3, // lớn hơn (>)
  LTE: 4, // nhỏ hơn hoặc bằng (<=)
  GTE: 5, // lớn hơn hoặc bằng (>=)
})

export const JOB_TITLE = Object.freeze({
  GD: 1, // Giám đốc
  QL: 4, // Quản lý cửa hàng
  KTBH: 6, // Kế toán bán hàng
  TDKH: 9, // Tiếp đón khách hàng
  KTPC: 10, // Kỹ thuật phần cứng
  KTNB: 19, // Kế toán nội bộ
  MKT: 21, // Nhân viên marketing
  TRADE_MKT: 94, // Trade marketing
  TVBH: 7, // Tư vấn bán hàng
  CM: 120, //Content media
  DPK: 121, //Điều phối kho
  GDTTBH: 122, //Giám đốc trung tâm bảo hành
  HTQL: 123, //Hỗ trợ quản lý
  HVTNCR: 124, //HV Trưởng nhóm CR
  KTT: 125, //Kế toán trưởng
  KDOL: 126, //Kinh doanh online
  NHPK: 127, //Ngành hàng Phụ kiện
  NSTH: 128, //Nhân sự tổng hợp
  NVGN: 129, //Nhân viên giao nhận
  NVKDB2B: 130, //Nhân viên kinh doanh B2B
  NVKDTT: 131, //Nhân viên kinh doanh thị trường
  NVT: 132, //Nhân viên Tester
  PC: 133, //Pháp chế
  PGD: 134, //Phó Giám đốc
  QLK: 135, //Quản lý kho
  TLKD: 136, //Trợ lý kinh doanh
  TCKTBH: 137, //Trưởng ca Kế toán bán hàng
  TCKTPM: 138, //Trưởng ca Kỹ thuật phần mềm
  TCTVBH: 139, //Trưởng ca Tư vấn bán hàng
  TNHAD: 140, //Trưởng Ngành Hàng Android
  TNCR: 141, //Trưởng nhóm CR
  TPKD: 142, //Trưởng Phòng Kinh Doanh
  TPKDB2B: 143, //Trưởng Phòng Kinh Doanh B2B
  TPPTNNL: 144, //Trưởng Phòng Phát Triển Nguồn Nhân Lực
  TVBHDN: 145, //Tư vấn bán hàng đa nhiệm
})

export const JOB_TITLE_ACCOUNTANT = Object.freeze([
  JOB_TITLE.KTNB,
  JOB_TITLE.GD,
  JOB_TITLE.PGD,
  JOB_TITLE.KTT,
])

export const ORDER_STATUS = Object.freeze({
  NEW: 1, // Mới
  CONFIRMING: 2, // Đang xử lí
  CONFIRMED: 3, // Đã xác nhận
  DELIVERY: 4, // Đang giao
  PACKING: 5, // Đang đóng gói
  SUCCESS: 6, // Thành công (Tồn)
  UN_SUCCESS: 7, // Không thành công
  SYSTEM_CANCEL: 8, // Hệ thống hủy
  REFUNDED: 9, // Đã chuyển hoàn
  NO_CATCHED_PHONE: 10, // Không bắt máy
  CR_CANCEL: 11, // CR huỷ
  //TODO xoá sau khi stable
  DEPOSIT: 12, // Đã đặt cọc
  AGREE_DEPOSIT: 13, // Đồng ý cọc
  // end TODO
  PREPARED: 14, // Đã chuẩn bị (Tồn)
  TRACKING: 15, // Đang theo dõi
  CUSTOMER_CANCEL: 16, // Khách hủy
  KEEP_DEPOSIT: 17, // Giữ cọc
  RETURNING: 18, // Đang chuyển hoàn (Shopee sync)
  DELIVERY_RECALL: 19, // Chờ thu hồi
  DELIVERY_FAILED: 20, // Giao thất bại (ecom)
})

// Trạng thái trả hàng từng phần của đơn (độc lập với ORDER_STATUS).
export const ORDER_RETURN_STATE = Object.freeze({
  NONE: 0, // Chưa trả hàng
  PARTIAL: 1, // Đã trả một phần
  FULL: 2, // Đã trả toàn bộ
})

export const ORDER_RETURN_STATE_NAME = Object.freeze({
  [ORDER_RETURN_STATE.NONE]: 'Chưa trả hàng',
  [ORDER_RETURN_STATE.PARTIAL]: 'Đã trả một phần',
  [ORDER_RETURN_STATE.FULL]: 'Đã trả toàn bộ',
})

export const BILL_TYPE = Object.freeze({
  RETAIL_INVOICE: 1, // hóa đơn bán lẻ
  WHOLESALE_INVOICE: 2, // hóa đơn bán buôn
  REFUND_INVOICE: 3, // trả hàng
  SHIPPING: 4, // hóa đơn giao hàng
  IMPORT_STOCK_FROM_TRANSFER: 5, // enum này dùng cho phiếu nhập kho từ phiếu chuyển kho
  WARRANTY: 6, // hóa đơn bảo hành
  CONVERT: 7, // hóa đơn chuyển đổi
})

export const STOCK_SLIP_RELATION_TYPE = Object.freeze({
  INDEPENDENT: 1, // Phiếu độc lập
  PARENT: 2, // Phiếu cha
  CHILD: 3, // Phiếu con
})

export const STOCK_HISTORY = Object.freeze({
  IMPORT_STOCK: 1, // nhap kho tu nha cung cap
  EXPORT_STOCK: 2, // xuat kho tra nha cung cap
  TRANSFER_STOCK: 3, // chuyen kho
  UPDATE_IMPORT_STOCK: 4, // cap nhat phieu nhap kho
  UPDATE_EXPORT_STOCK: 5, // cap nhat phieu xuat kho
  EXPORT_TO_TRANSFER: 6, // xuat chuyen kho
  IMPORT_FROM_TRANSFER: 7, // nhap chuyen kho
  EXPORT_TO_SALE_RETAIL: 8, // xuat kho ban le
  EXPORT_TO_SALE_WHOLE_SASE: 9, // xuat kho bán buon
  IMPORT_FROM_RETURN_BILL: 10, // nhap kho tu phieu tra hang
  IMPORT_FROM_REFUND_ORDER: 11, // nhập kho từ đơn chuyển hoàn
  EXPORT_TO_SHIPPING: 12, // xuất kho giao hàng
  INVENTORY_BALANCE: 13, // cân kho
  IMPORT_WARRANTY: 14, // nhập kho bảo hành
  UPDATE_IMPORT_WARRANTY: 15, // cập nhật nhập kho bảo hành
  EXPORT_WARRANTY: 16, // xuất kho bảo hành
  UPDATE_EXPORT_WARRANTY: 17, // cập nhật xuất kho bảo hành
  CHANGE_PRODUCT_IMEI: 18, // đổi sản phẩm IMEI
  REMOVE_FROM_BILL: 19, // xóa SP trong hóa đơn
  REMOVE_BILL: 20, // xóa hóa đơn
  REMOVE_RETURN_BILL: 21, // xóa hóa đơn trả hàng
  UPDATE_EXPORT_TO_SALE: 22, // cập nhật hóa đơn
  DELETE_TRANSFER_STOCK: 23, // xóa phiếu chuyển kho
  DELETE_IMPORT_STOCK: 24, // xoa phieu nhap kho tu nha cung cap
  DELETE_EXPORT_STOCK: 25, // xoa phieu xuat kho tra nha cung cap
  IMPORT_FROM_TRADE_IN: 26, // nhập kho thu cũ
  CANCEL_TRANSFER: 27, // hủy phiếu chuyển
  IMPORT_HOLDING: 28, // nhập kho giữ hàng
  UPDATE_IMPORT_HOLDING: 29, // cập nhật nhập kho giữ hàng
  DELETE_IMPORT_HOLDING: 30, // xóa phiếu nhập kho giữ hàng
  EXPORT_HOLDING: 31, // xuất trả giữ hàng
  DELETE_EXPORT_HOLDING: 32, // xóa phiếu xuất trả giữ hàng
  CANCEL_HOLDING: 33, // hủy phiếu giữ hàng
  DELETE_IMPORT_WARRANTY: 34, // xoa phieu nhap kho tu bao hanh
  DELETE_EXPORT_WARRANTY: 35, // xoa phieu xuat kho tra bao hanh
  DELETE_IMPORT_TRADE_IN: 36, // xoa phieu nhap kho tu bao hanh
  IMPORT_WARRANTY_FROM_BILL: 37, // nhập kho bảo hành từ hóa đơn
  EXPORT_WARRANTY_FROM_BILL: 38, // xuất kho bảo hành từ hóa đơn
  UPDATE_IMPORT_WARRANTY_FROM_BILL: 39, // cập nhật nhập kho bảo hành từ hóa đơn
  UPDATE_EXPORT_WARRANTY_FROM_BILL: 40, // cập nhật xuất kho bảo hành từ hóa đơn
  DELETE_IMPORT_WARRANTY_FROM_BILL: 41, // xóa phiếu nhập kho bảo hành từ hóa đơn
  DELETE_EXPORT_WARRANTY_FROM_BILL: 42, // xóa phiếu xuất kho bảo hành từ hóa đơn
  EXPORT_STOCK_BY_WARRANTY_BILL: 43, // xuất kho bởi đổi sp từ hóa đơn bảo hành
  DELETE_REQUIRE_EXPORT_WARRANTY_STOCK: 44, // xóa phiếu yêu cầu xuất nhập kho bảo hành
  EXPORT_WARRANTY_TO_PROVIDER: 45, // xuất kho trả nhà cung cấp
  UPDATE_EXPORT_WARRANTY_TO_PROVIDER: 46, // cập nhật xuất kho trả nhà cung cấp
  DELETE_EXPORT_WARRANTY_TO_PROVIDER: 47, // xóa xuất kho trả nhà cung cấp
  IMPORT_STOCK_BY_WARRANTY_COMPLETION: 48, // nhập kho bởi phiếu hoàn tất bảo hành
  EXPORT_STOCK_BY_WARRANTY_COMPLETION: 49, // xuất kho bởi phiếu hoàn tất bảo hành
  CREATE_WARRANTY_COMPLETION_SLIP: 50, // xuất kho bởi phiếu hoàn tất bảo hành
  DELETE_WARRANTY_COMPLETION_SLIP: 51, // xuất kho bởi phiếu hoàn tất bảo hành
  DELETE_IMPORT_STOCK_BY_WARRANTY_COMPLETION: 52, // xoá phiếu nhập kho bởi phiếu hoàn tất bảo hành
  DELETE_EXPORT_STOCK_BY_WARRANTY_COMPLETION: 53, // xoá phiếu xuất kho bởi phiếu hoàn tất bảo hành
  EXPORT_WARRANTY_STOCK_BY_DELETE_WARRANTY_BILL: 54, // xuất kho bảo hành bởi xoá hoá đơn bảo hành
  IMPORT_STOCK_BY_DELETE_WARRANTY_BILL: 55, // nhập kho bởi xoá hoá đơn bảo hành
  IMPORT_STOCK_BY_DELETE_STORE_WARRANTY_BILL: 56, // nhập kho bởi xoá hoá đơn bảo hành (lỗi do cửa hàng)
  EXPORT_STOCK_BY_CREATE_STORE_WARRANTY_BILL: 57, // xuất kho bởi tạo hoá đơn bảo hành (lỗi do cửa hàng)
  DELETE_EXPORT_STOCK_BY_CREATE_STORE_WARRANTY_BILL: 58, // nhập kho bởi xoá đơn bảo hành(do lỗi phát sinh cửa hàng)
  EXPORT_STOCK_BY_INVENTORY_CHECK: 59, // xuất kho từ phiếu kiểm kê sản phẩm
  IMPORT_STOCK_BY_INVENTORY_CHECK: 60, // nhập kho từ phiếu kiểm kê sản phẩm
  EXPORT_LENDING: 61, // xuất kho cho mượn máy
  UPDATE_EXPORT_LENDING: 62, // cập nhật phiếu xuất kho cho mượn máy
  DELETE_EXPORT_LENDING: 63, // xoá phiếu xuất kho cho mượn máy
  IMPORT_STOCK_LENDING: 64, // nhập kho nhận máy cho mượn
  IMPORT_WARRANTY_FROM_PROVIDER: 65, // nhập kho sản phẩm bảo hành từ nhà cung cấp
})

export const VALUATION_REQUEST_STATUS = Object.freeze({
  NEW: 1, // Mới
  PROCESSING: 2, // Đang xử lý
  CONFIRMED: 3, // Đã xác nhận
  NO_CONTACT: 4, // Không liên hệ được
  SUCCESS: 5, // Thành công
  CANCEL: 6, // Hủy
})

export const JOB_TITLE_ORDER = Object.freeze({
  CR: [JOB_TITLE.QL_CSKH, JOB_TITLE.CSKH, JOB_TITLE.CTV_CSKH],
  SHOP: [
    JOB_TITLE.ASM,
    JOB_TITLE.QL,
    JOB_TITLE.TL,
    JOB_TITLE.KTBH,
    JOB_TITLE.TVBH,
    JOB_TITLE.KTPM,
    JOB_TITLE.TDKH,
    JOB_TITLE.KTPC,
  ],
  DP: [JOB_TITLE.DP, JOB_TITLE.QL_DP],
})

export const JOB_TITLE_EMLOYEE_STORE = Object.freeze([
  JOB_TITLE.KTBH,
  JOB_TITLE.TVBH,
  JOB_TITLE.KTPM,
  JOB_TITLE.TDKH,
  JOB_TITLE.KTPC,
])

export const JOB_TITLE_SHOW_BY_OWNER = Object.freeze([JOB_TITLE.QL, JOB_TITLE.TL])

export const PURCHASE_ORDER_STATUS = Object.freeze({
  NEW: 1, // Mới
  PURCHASE: 2, // Ngành hàng
  ACCOUNTANT: 3, // Kế toán
  PO_HEAD_CANCEL: 4, // trưởng ngành hàng hủy phiếu
  ACCOUNTANT_CANCEL: 5, // kế toán hủy phiếu
  READY: 6, // sẵn sàng để duyệt
  CANCELED: 7, // hủy yêu cầu
  SHOP_APPROVAL: 8, // AM duyệt đơn từ cửa hàng
})

export const PURCHASE_ORDER_SOURCE = Object.freeze({
  STORE: 1, // nguồn cửa hàng
  PURCHASE: 2, // nguồn ngành hàngß
  // DEAL_SHEET: 3, // nguồn deal sheet
});

export const PURCHASE_ORDER_APPROVE_MODE = Object.freeze({
  PURCHASE: 'purchase',
  ACCOUNTANT: 'accountant',
})

export const PURCHASE_ORDER_TYPE = Object.freeze({
  IMPORT: 1,
  CONSIGNMENT: 2,
})

export const PO_SENT_STATUS = Object.freeze({
  NEW: 0,
  SENT_FAIL: 1,
  SENT_SUCCESS: 2,
})

export const PO_RELATION_TYPE = Object.freeze({
  INDEPENDENT: 1,
  PARENT: 2,
  CHILD: 3,
})

export const BILL_ITEM_TYPE = Object.freeze({
  PRODUCT: 1, // sản phẩm
  PRODUCT_BONUS: 2, // sản phẩm tặng kèm
  PRODUCT_PROMTION: 3, // sản phẩm bán kèm
  RETURN_WARRANTY: 4, // sản phẩm trả bảo hành
})

export const APPROVAL_CONFIG_OWNER_TYPE = Object.freeze({
  POSITION: 1, // Chức vụ
  IDENTIFICATION: 2, // Đích danh
  AUTO_APPROVE: 3, // Tự động duyệt
})

export const ACTIVE_STATUS_COMMON = Object.freeze({
  ENABLED: 1,
  DISABLED: 0,
})

export const REWARD_CHECK_TYPE = Object.freeze({
  CH: 'CH',
  CR: 'CR',
})

export const OPERATOR_TRANS_TYPE = Object.freeze({
  ADD: 1, // cộng
  SUBTRACT: 2, // trừ
})

export const STOCK_CHECK_PRODUCT_LOG_SOURCE_TYPE = Object.freeze({
  SCAN_QR_CODE: 1, // Scan QR
  MOBILE_MANUAL: 2, // Tích thủ công từ mobile
  WEB_MANUAL: 3, // Tích thủ công từ web
})

export const STOCK_CHECK_SHEET_STATUS = Object.freeze({
  NEW: 1, // Mới
  DONE: 2, // Hoàn Thành difference STOCK_CHECK_SHEET_STATUS.STOCK_DIFF
  STOCK_DIFF: 3, // Phiếu lệch kho cần kế toán xử lý
  // STOCK_DEBT: 4, //  truy thu lệch kho
  COMFIRM: 5, // xác nhận kiểm kê
})

export const STOCK_CHECK_PRODUCT_SEARCH_TYPE = Object.freeze({
  PRODUCT_NAME: 1, // tìm theo tên, mã, mã vạch
  PRODUCT_IMEI: 2, // tìm theo mã IMEI
  BARCODE_SCANNER: 3, // tìm theo máy quét mã vạch
})
export const ORDER_TYPE = Object.freeze({})

export const JOB_TITLE_APPROVE = Object.freeze([JOB_TITLE.ASM, JOB_TITLE.RSM, JOB_TITLE.GD])

export const TRANSFER_STORE_FORM_STATUS = Object.freeze({
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
  APROVED_TRANSFER: 4,
})

export const DEAL_SHEET_PROGRAM_TYPE = Object.freeze({
  HOT_SALE: 1,
  JBP: 2,
})

export const DEAL_SHEET_TARGET_TYPE = Object.freeze({
  SALE_OUT: 1,
  SALE_IN: 2,
})

export const DEAL_SHEET_PRIORITY = Object.freeze({
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
})

export const WARRANTY_RECEPTION_STATUS = Object.freeze({
  RECEIVING: 'RECEIVING', // Đang tiếp nhận
  REPAIRING: 'REPAIRING', // Đang sửa
  REPAIRED: 'REPAIRED', // Đã sửa
  COMPLETED: 'COMPLETED', // Hoàn thành
  RETURNED: 'RETURNED', // Đã trả
  REJECTED: 'REJECTED', // Đã từ chối
})

export const WARRANTY_OUTSOURCE_STATUS = Object.freeze({
  SENT: 'SENT', // Đã xuất
  RECEIVED: 'RECEIVED', // Đã nhận về
})

export const ADJUSTMENT_DRAFT_STATUS = Object.freeze({
  DRAFT: 'DRAFT',
  READY_TO_ISSUE: 'READY_TO_ISSUE',
  ISSUING: 'ISSUING',
  ISSUED: 'ISSUED',
  WAITING_PROVIDER: 'WAITING_PROVIDER',
  ISSUE_FAILED: 'ISSUE_FAILED',
  RETRYING: 'RETRYING',
  FAST_SYNCING: 'FAST_SYNCING',
  FAST_SYNCED: 'FAST_SYNCED',
  FAST_SYNC_FAILED: 'FAST_SYNC_FAILED',
  DELETED: 'DELETED',
  CANCELLED: 'CANCELLED',
})

/** Khớp backend `einvoice/adjustment/constants` AUDIT_ACTION — audit log `action` */
export const ADJUSTMENT_AUDIT_ACTION = Object.freeze({
  CREATED: 'CREATED',
  STATUS_CHANGED: 'STATUS_CHANGED',
  ISSUED: 'ISSUED',
  RETRIED: 'RETRIED',
  DELETED: 'DELETED',
  FAST_SYNC_TRIGGERED: 'FAST_SYNC_TRIGGERED',
  FAST_SYNC_SUCCESS: 'FAST_SYNC_SUCCESS',
  FAST_SYNC_FAILED: 'FAST_SYNC_FAILED',
  BUYER_TAX_CODE_EDITED: 'BUYER_TAX_CODE_EDITED',
})

export const RETURN_BILL_ADJUSTMENT_LIST_FILTER = Object.freeze({
  ALL: 'ALL',
  NO_ADJUSTMENT: 'NO_ADJUSTMENT',
  IN_PROGRESS: 'IN_PROGRESS',
  DRAFT: ADJUSTMENT_DRAFT_STATUS.DRAFT,
  ISSUED: ADJUSTMENT_DRAFT_STATUS.ISSUED,
  ISSUE_FAILED: ADJUSTMENT_DRAFT_STATUS.ISSUE_FAILED,
  FAST_SYNC_FAILED: ADJUSTMENT_DRAFT_STATUS.FAST_SYNC_FAILED,
})

export const RETURN_BILL_ADJUSTMENT_IN_PROGRESS_DRAFT_STATUSES = Object.freeze([
  ADJUSTMENT_DRAFT_STATUS.ISSUING,
  ADJUSTMENT_DRAFT_STATUS.RETRYING,
  ADJUSTMENT_DRAFT_STATUS.WAITING_PROVIDER,
])

export const RETURN_BILL_ADJUSTMENT_LIST_FILTER_OPTIONS = Object.freeze([
  { value: RETURN_BILL_ADJUSTMENT_LIST_FILTER.ALL, text: 'Tất cả trạng thái' },
  { value: RETURN_BILL_ADJUSTMENT_LIST_FILTER.NO_ADJUSTMENT, text: 'Chưa có HĐĐC' },
  { value: RETURN_BILL_ADJUSTMENT_LIST_FILTER.DRAFT, text: 'Nháp' },
  { value: RETURN_BILL_ADJUSTMENT_LIST_FILTER.IN_PROGRESS, text: 'Đang xử lý' },
  { value: RETURN_BILL_ADJUSTMENT_LIST_FILTER.ISSUED, text: 'Đã phát hành' },
  { value: RETURN_BILL_ADJUSTMENT_LIST_FILTER.ISSUE_FAILED, text: 'Lỗi phát hành' },
  { value: RETURN_BILL_ADJUSTMENT_LIST_FILTER.FAST_SYNC_FAILED, text: 'Lỗi đồng bộ FAST' },
])

export const HISTORY_TYPE = Object.freeze({
  ORDER: 1, // đơn hàng
  BILL: 2, // bán hàng
  PRODUCT: 3, // sản phẩm
  PRODUCT_IMEI: 4, // sản phẩm IMEI
  PRE_ORDER: 5, // đơn đặt trước
  STOCK_SLIP: 6, // phiếu kho
  SETTING: 7, // cấu hình hệ thống
  WARRANTY: 8, // bảo hành
})

export const PAGE_ACTION = Object.freeze({
  CREATE: 'create',
  UPDATE: 'update',
})

export const IMEI_ACTIVE_STATUS = Object.freeze({
  NEW: 1, //Mới
  ACTIVED: 2, //Đã kích hoạt
})

export const REWARD_CATEGORY_TYPE = Object.freeze({
  REVENUE: 1, // theo doanh thu
  QUANTITY: 2, // theo số công
})

export const TARGET_TYPE = Object.freeze({
  REVENUE: 'DT', // doanh thu
  QUANTITY: 'SL', // số lượng
})

export const DISCOUNT_POLICY_TYPE = Object.freeze({
  SALE_IN: 'SI',
  SALE_OUT: 'SO',
  BVG: 'BVG',
})

export const WARRANTY_TRANSFER_STATUS = Object.freeze({
  NONE: 'NONE',
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
})

export const VTP_PAYMENT_METHOD = Object.freeze({
  NO_COLLECTION: 1, // Không thu hộ
  COLLECT_BOTH: 2, // Thu hộ tiền hàng và tiền cước
  COLLECT_GOODS_ONLY: 3, // Thu hộ tiền hàng, không thu hộ tiền cước
  COLLECT_SHIPPING_ONLY: 4, // Thu hộ tiền cước, không thu hộ tiền hàng
})

export const NT_PAYMENT_METHOD = Object.freeze({
  SENDER_PAY_LATER: 11, // Người gửi thanh toán sau
  SENDER_PAY_NOW: 10, // Người gửi thanh toán ngay
  RECEIVER_PAY_NOW: 20, // Người nhận thanh toán ngay
})

export const DEAL_SHEET_SOURCE_TYPE = Object.freeze({
  BILL: 'bill', // bán hàng
  WHOLESALE: 'wholesale', // bán buôn
  STOCK_SLIP: 'stockSlip', // nhập kho
  IMPORT_EXCEL: 'import_excel', // import phát sinh từ file excel
  ACTIVE: 'active', // kích hoạt IMEI
});
